import { useSelector } from 'react-redux';

import { Box, Typography } from '@material-ui/core';

import { Button } from 'components';

import { useRejectLinkRequest } from 'hooks/nutritionist.hook';

const RejectLinkRequest = () => {
  const { data } = useSelector(state => state.patient);

  const { mutate, isLoading } = useRejectLinkRequest();

  const onClickHandler = () => {
    mutate(data.requestId);
  };

  return (
    <Box>
      <Typography>
        ¿Confirmas rechazar la solicitud de este paciente?
      </Typography>
      <Typography>No se podrá revertir esta acción</Typography>
      <Box mt={2} textAlign="center">
        <Button
          onClick={onClickHandler}
          variant="contained"
          color="primary"
          loading={isLoading}
        >
          Confirmar
        </Button>
      </Box>
    </Box>
  );
};

export default RejectLinkRequest;
